import styled from 'styled-components';

import { Z_INDEX } from '@hero/constants';

const Loader = styled.div`
  align-content: center;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  margin: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${Z_INDEX.loader};
`;

const LoaderBody = styled.div`
  align-content: center;
  align-items: center;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const LoaderFooter = styled.span`
  background-color: var(--color-bg-body);
  bottom: 60px;
  color: var(--color-fg-default);
  font-size: 12px;
  padding: 4px;
  position: absolute;
`;

const LoaderAnimation = styled.div`
  animation: l21 0.6s infinite alternate linear;
  aspect-ratio: 1;
  border-radius: 50%;
  box-shadow:
    19px 0 0 7px,
    38px 0 0 3px,
    57px 0 0 0;
  color: var(--color-accent-secondary-stronger);
  margin-top: 40px;
  transform: translateX(-38px);
  width: 4px;

  @keyframes l21 {
    50% {
      box-shadow:
        19px 0 0 3px,
        38px 0 0 7px,
        57px 0 0 3px;
    }
    100% {
      box-shadow:
        19px 0 0 0,
        38px 0 0 3px,
        57px 0 0 7px;
    }
  }
`;

export { Loader, LoaderAnimation, LoaderBody, LoaderFooter };
